import { useContext, useState } from 'react';

import Button from '../../button/button.component';

import { ToastContext } from '../../../../contexts/toast.context';

import {
    ContentContainer,
    Input,
    Label,
    Textarea
} from '../../../../styles/component.styles';

const ProductFormSeeds = ({ product = null, category, productType, action, buttonName = 'Add Product' }) => {
    const [ name, setName ] = useState(product ? product.name : '');
    const [ description, setDescription ] = useState(product ? product.description : '');
    const [ time, setTime ] = useState(product ? product.details.time : '');
    const [ mother, setMother ] = useState(product ? product.details.mother : '');
    const [ father, setFather ] = useState(product ? product.details.father : '');
    
    const { errorToast } = useContext(ToastContext);

    const addProduct = async () => {
        if(name === '' || 
            description === '' ||
            time === '' ||
            mother === '' ||
            father === ''
        ) {
            errorToast('Please fill out all fields.');
            return;
        }

        const data = {
            category,
            productType,
            name,
            description,
            time,
            mother,
            father
        };

        await action(data);
    }

    return (
        <ContentContainer>
            <Input type='text' name='name' value={name} onChange={(e) => setName(e.target.value)} placeholder='Name' />
            <Textarea name='description' value={description} onChange={(e) => setDescription(e.target.value)} placeholder='Description' />
            <Input type='text' name='time' value={time} onChange={(e) => setTime(e.target.value)} placeholder='Time' />
            <Input type='text' name='mother' value={mother} onChange={(e) => setMother(e.target.value)} placeholder='Mother' />
            <Input type='text' name='father' value={father} onChange={(e) => setFather(e.target.value)} placeholder='Father' />

            <ContentContainer margin='20px'>
                <Button onClick={() => addProduct()}>{ buttonName }</Button>
            </ContentContainer>
        </ContentContainer>
    )
}

export default ProductFormSeeds;